/**
 * Unwrap image if only child, from <p><img></p>
 */
(function($){
    // https://stackoverflow.com/questions/43204996/how-to-remove-p-tags-surrounding-img-using-jquery
    $('p:has(img)').each(function() {
        $(this).before($(this).find('>img'));
        if(!$.trim(this.innerHTML).length) $(this).remove();
    });
})(jQuery);
